import * as React from 'react'
import { useState } from 'react'
import { Overlay } from './Overlay'
import { styled } from '../../../../shared/styled-components'
import { Utils } from '../../../../shared/Utils'
import { Headline } from '../../../../shared/components/Headlines'
import { OverlayCloseButton } from './OverlayCloseButton'
import { Loading } from '../../../../shared/components/Loading'
import useAsyncEffect from 'use-async-effect'
import { inject } from 'mobx-react'
import { APIService } from '../../../../shared/APIService'
import { OfferInstance } from '../../../../models/Offer'

interface IProps {
  api?: APIService
  offer: OfferInstance
  onClose?: () => any
}

export const SendReportOverlay = inject('api')(({ api, onClose, offer }: IProps) => {
  const [loading, setLoading] = useState(true)
  useAsyncEffect(async () => {
    try {
      await api!.requestReport(offer.code)
    } catch (e) {
      console.error(e)
      alert(
        'Beim Versand Ihres Analyseberichts ist ein Fehler aufgetreten. Bitte kontaktieren Sie uns über info@implacheck.de.'
      )
    }
    setLoading(false)
  }, [])

  return (
    <Overlay>
      <Container>
        {loading ? (
          <Loading />
        ) : (
          <>
            <CloseButton onClick={onClose} />
            <ToothImage src={Utils.getAssetPath('/assets/calculator/result/implatooth.svg')} />
            <OverlayHeadline>Bitte bestätigen Sie Ihre E-Mail-Adresse</OverlayHeadline>

            <Steps>
              <Step>
                <StepIcon src={Utils.getAssetPath('/assets/calculator/result/mail-green.svg')} />
                <StepText>
                  <StepTitle>Prüfen Sie Ihren Posteingang</StepTitle>
                  <StepText>
                    Gehen Sie zum Posteingang der E-Mail-Adresse, mit der Sie sich auf der vorherigen Seite angemeldet
                    haben.
                  </StepText>
                </StepText>
              </Step>

              <Step>
                <StepIcon src={Utils.getAssetPath('/assets/calculator/result/mail-open-green.svg')} />
                <StepText>
                  <StepTitle>Öffnen Sie die Bestätigungsmail</StepTitle>
                  <StepText>
                    Finden Sie die von "implacheck&reg;" gesendete E-Mail. Sie hat den Betreff "Nur noch ein Klick..."
                  </StepText>
                </StepText>
              </Step>

              <Step>
                <StepIcon src={Utils.getAssetPath('/assets/calculator/result/click-green.svg')} />
                <StepText>
                  <StepTitle>Analysebericht öffnen</StepTitle>
                  <StepText>Öffnen Sie den PDF-Anhang der E-Mail, er beinhaltet Ihren Analysebericht.</StepText>
                </StepText>
              </Step>
            </Steps>
          </>
        )}
      </Container>
    </Overlay>
  )
})

const Container = styled.div`
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`

const ToothImage = styled.img``

const OverlayHeadline = styled(Headline)`
  color: white;
  font-weight: normal;
  @media (max-width: 950px) {
    margin-bottom: 30px;
  }
`

const Steps = styled.ul`
  list-style: none;
`
const Step = styled.li`
  display: flex;
  flex-direction: row;
  margin-bottom: 3rem;
`
const StepIcon = styled.img`
  margin-right: 1rem;
  height: 3rem;
`
const StepText = styled.div`
  display: flex;
  flex-direction: column;
`
const StepTitle = styled.h4`
  font-size: 1.5rem;
`
const StepText = styled.div`
  font-size: 1rem;
`

const CloseButton = styled(OverlayCloseButton)`
  position: absolute;
  bottom: calc(100% + 1rem);
  left: calc(100% + 1rem);
  @media (max-width: 950px) {
    left: calc(100% - 70px);
  }
`
